export default __webpack_public_path__ + "3d0107dd43d0101274d38543b52c6ffa.woff";